function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Fichier 54");

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 603.73 1093.99",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, React.createElement("g", {
    id: "VALIDATION_DEFIS"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M302.49,20.74h0C457.4,20.74,583,146.32,583,301.24v510c0,154.91-125.59,280.5-280.5,280.5h0C147.57,1091.74,22,966.15,22,811.24v-510C22,146.32,147.57,20.74,302.49,20.74Z",
    style: {
      fill: "none",
      stroke: "#1d1899",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), React.createElement("path", {
    d: "M302.49,142.24h0c103.83,0,188,84.17,188,188v463c0,103.83-84.17,188-188,188h0c-103.83,0-188-84.17-188-188v-463C114.49,226.41,198.66,142.24,302.49,142.24Z",
    style: {
      fill: "none",
      stroke: "#1d1899",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), React.createElement("path", {
    d: "M303,255.24h0a109.5,109.5,0,0,1,109.5,109.5v383A109.51,109.51,0,0,1,303,857.24h0a109.5,109.5,0,0,1-109.5-109.5v-383A109.49,109.49,0,0,1,303,255.24,529.62,975.86a280.11,280.11,0,0,1-227.13,115.88h0C147.57,1091.74,22,966.15,22,811.24Z",
    style: {
      fill: "none",
      stroke: "#1d1899",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.1ce5b8b4.svg";
export { ForwardRef as ReactComponent };